export default {
    install(Vue) {
        Vue.mixin({
            methods: {
                makeToast(variant = null, content, title, position) {
                    this.$bvToast.toast(content, {
                        toaster: position,
                        title: title,
                        variant: variant,
                        solid: true
                    })
                },
                invalidHttpStatusCode(statusCode) {
                    if (statusCode && statusCode >= 400) {
                        return true
                    }
                    return false
                }
            }
        })
    }
};
